export const RESET_JSON_LD = 'RESET_JSON_LD';
export const ADD_JSON_LD_ARTICLE = 'ADD_JSON_LD_ARTICLE';
export const ADD_JSON_LD_LOCAL_BUSINESS = 'ADD_JSON_LD_LOCAL_BUSINESS';
export const ADD_JSON_LD_BREAD_CRUMB_LIST = 'ADD_JSON_LD_BREAD_CRUMB_LIST';
export const ADD_JSON_LD_FAQ = 'ADD_JSON_LD_BREAD_FAQ';
export const resetJsonLd = () => ({
    type: RESET_JSON_LD,
});
export const addJsonLdArticle = ({ author, datePublished, headline, image, mainEntityOfPage, }) => ({
    payload: {
        author,
        datePublished,
        headline,
        image,
        mainEntityOfPage,
    },
    type: ADD_JSON_LD_ARTICLE,
});
export const addJsonLdLocalBusiness = () => ({
    type: ADD_JSON_LD_LOCAL_BUSINESS,
});
export const addJsonLdBreadcrumbList = (itemListElement) => ({
    payload: { itemListElement },
    type: ADD_JSON_LD_BREAD_CRUMB_LIST,
});
export const addJsonLdFaq = (mainEntity) => ({
    payload: { mainEntity },
    type: ADD_JSON_LD_FAQ,
});
